import React, { Fragment } from 'react';
import { StyleSheet, css } from 'aphrodite';
import Grid from '@material-ui/core/Grid';
import { StatusTile } from './StatusTile';
import { CommonStyles } from '../styles/Styles';

export function VenueStatusTiles(props) {

  return (
    <Fragment>
      {props.items.map((item, index) => {
        return (
          <div key={'status-' + index} className={css(Styles.statusCard)}>
            <div className={css(Styles.itemTitle)}>{item.title}</div>
            <div className={css(Styles.values)}>
              <span>
                {item.icon && (
                  <div className={css(Styles.imgContainer,props.iconContainer)}>
                    <i className='material-icons-outlined' style={{ fontSize: 18, padding: 5 }}>{item.icon}</i>
                  </div>
                )}
                {item.image && (
                  <div className={css(Styles.imgContainer,props.iconContainer)}>
                    <img className={css(Styles.statsImage)}  src={item.image} />
                  </div>
                )}
              </span>
              <span className={css(Styles.itemValue)}>
                {item.value ? item.value : '-'}
              </span>
            </div>
          </div>
          // key={'status-' + index}
          // keyData={index}
          // item={item}
          // {...props} />
        )
      })}
    </Fragment>
  )
}

const Styles = StyleSheet.create({
  statsImage: {
    width: 22,
    height: 22
  },
  statusCard:{
    margin: '6px 20px 0px  !important',
    padding: '3px 0px',
    borderBottom: '#D7D7D7 solid 1px',
    ':last-child':{
      border: 'none'
    }
  },
  itemTitle:{
    fontSize: 14,
    color: '#121212'
  },
  itemValue:{
    fontSize: 16,
    color: '#121212',
    paddingLeft:10,
    '@media (max-width: 1024px)': {
      fontSize: 22,
    }
  },
  values:{
    display: 'flex',
    paddingTop: 4
  }
})


// WEBPACK FOOTER //
// ./src/components/VenueStatusTiles.js